import { useQuery } from '@tanstack/react-query';
import { queryKeys, missionControlService } from '@v2/services';
import type { PluginVersion } from '@v2/types';

interface UsePluginVersionsResult {
  versions: PluginVersion[];
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export const usePluginVersions = (pluginId: string | null): UsePluginVersionsResult => {
  const trimmedId = pluginId?.trim() || '';

  const query = useQuery({
    queryKey: queryKeys.missionControl.plugins.versions(trimmedId),
    queryFn: () => missionControlService.getPluginVersions(trimmedId),
    enabled: !!trimmedId,
  });

  return {
    versions: query.data ?? [],
    loading: query.isLoading,
    error: query.error instanceof Error ? query.error.message : null,
    refetch: async () => {
      await query.refetch();
    },
  };
};

export default usePluginVersions;
